import {
  PREFERRED_LOCALE_STORAGE_KEY,
  ENGLISH_SPEAKING_LOCALES,
  DEFAULT_LOCALE
} from '../constants'
import { getStorage } from 'plugin/src/shared/storage'
import { isInExtension } from '../extension'
import { canAccessLocalStorage, canAccessWebLocalStorage } from '../browser'

export const getPreferredLocaleFromStorage = async () => {
  const canUseLocalStorage = await canAccessLocalStorage()

  if (!canUseLocalStorage) return DEFAULT_LOCALE

  const locale = isInExtension()
    ? (await getStorage('preferredLocale'))?.preferredLocale ?? DEFAULT_LOCALE
    : window.localStorage.getItem(PREFERRED_LOCALE_STORAGE_KEY)

  return locale || DEFAULT_LOCALE
}

export const setPreferredLocaleInStorage = newLocale => {
  if (!canAccessWebLocalStorage()) return

  localStorage.setItem(PREFERRED_LOCALE_STORAGE_KEY, newLocale)
}

export const isEnglishSpeakingLocale = locale => {
  return ENGLISH_SPEAKING_LOCALES.includes(locale)
}
